import './bootstrap';

import { createApp, h } from 'vue';
import {createInertiaApp, usePage} from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { ZiggyVue, route as ziggyRoute } from '../../vendor/tightenco/ziggy';
import { i18nVue } from 'laravel-vue-i18n';
import VueGtag from 'vue-gtag';
import Bugsnag from '@bugsnag/js';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import Vue3JsonLD from 'vue3-json-ld';


const appName = import.meta.env.VITE_APP_NAME || 'Laravel';

window.route = (name, params, absolute, config) => {
    try {
        return ziggyRoute(name, params, absolute, config);
    } catch (e) {
        if (! e.message.includes('is not in the route list')) {
            throw e;
        }

        let locale = document.documentElement.lang;

        let supportedLocales = usePage().props.supported_languages;
        if (! supportedLocales.includes(locale)) {
            locale = usePage().props.fallback_locale;
        }

        return ziggyRoute(`${locale}.${name}`, params, absolute, config);
    }
}

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    setup({ el, App, props, plugin }) {
        const app = createApp({ render: () => h(App, props) });
        const pinia = createPinia();
        pinia.use(piniaPluginPersistedstate);

        if (Bugsnag.isStarted()) {
            app.use(Bugsnag.getPlugin('vue'));
        }

        app.use(i18nVue, {
                resolve: lang => {
                    const langs = import.meta.glob('../../lang/*.json', { eager: true });
                    return langs[`../../lang/${lang}.json`].default;
                }
            })
            .use(plugin)
            .use(ZiggyVue)
            .use(Vue3JsonLD)
            .use({
                install(app) {
                    app.config.globalProperties.route = window.route;
                },
            })
            .use(VueGtag, {
                config: { id: 'GTM-KQDTGVLB' },
            })
            .use(pinia)
            .component('button-component', () => import('@components/button.vue'))
            .component('large-image-text-component', () => import('@components/large-image-text.vue'))
            .component('our-materials-component', () => import('@components/our-materials.vue'))
            .component('product-type-component', () => import('@components/product-type.vue'))
            .component('divider-component', () => import('@components/divider.vue'))
            .component('blog-item-component', () => import('@components/blog-item.vue'))
            .component('step-component', () => import('@components/step.vue'))
            .component('tabs-component', () => import('@components/tabs.vue'))
            .mount(el);

        return app;
    },
    progress: {
        color: '#4B5563',
    },
});
